import React, { useContext } from 'react';

import { Banner } from '@riac/design-system';
import { GlobalBannerContext } from 'src/lib/GlobalBannerContext';

export type GlobalBannerContainerProps = React.PropsWithChildren<{}>;

export const GlobalBannerContainer = (props: GlobalBannerContainerProps): JSX.Element => {
  const { banners } = useContext(GlobalBannerContext);

  return (
    <>
      {Object.keys(banners).map((bannerId) => (
        <Banner noBorder key = {bannerId} {...banners[bannerId]}/>
      ))}
    </>
  );
};
